import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pantry-search-list-line-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantrySearchListItem = _resolveComponent("PantrySearchListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getList(), (item) => {
      return (_openBlock(), _createBlock(_component_PantrySearchListItem, {
        class: "pantry-search-list-item",
        key: item.id,
        recipeImageUrl: item.imageUrl,
        recipeLabel: item.name,
        recipeId: item.recipeId,
        type: item.type,
        onSelectRecipe: _ctx.onSelectRecipe
      }, null, 8, ["recipeImageUrl", "recipeLabel", "recipeId", "type", "onSelectRecipe"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}